// utils/helpers.js - Helper functions for the application
export const dataURLToBlob = (dataURL) => {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new Blob([u8arr], { type: mime });
};

export const blobToFile = (blob, fileName) => {
  return new File([blob], fileName, { type: blob.type });
};

export const fileToDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const getImageDimensions = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
        aspectRatio: img.width / img.height
      });
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
};

/**
 * Converts an external image URL to a proxied URL to avoid CORS issues
 * @param {string} url - The original image URL
 * @returns {string} - The proxied URL
 */
export const getProxiedImageUrl = (url) => {
  // Skip proxying for data URLs or relative URLs
  if (!url || url.startsWith('data:') || url.startsWith('/')) {
    return url;
  }
  
  // Skip proxying for same-origin URLs
  const currentOrigin = window.location.origin;
  if (url.startsWith(currentOrigin)) {
    return url;
  }
  
  // Use our proxy endpoint for external URLs
  const apiUrl = process.env.REACT_APP_API_URL || '';
  return `${apiUrl}/api/files/proxy?url=${encodeURIComponent(url)}`;
};
